const accessToken = localStorage.getItem('sessionToken');
export default accessToken;
